var map = {
	"./image001.png": 538,
	"./image002.png": 3883,
	"./image003.png": 443,
	"./image004.png": 2508,
	"./image005.png": 2009,
	"./image006.png": 4251,
	"./image007.png": 3542,
	"./image008.png": 8758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3048;